import types from './actionTypes';
import { AccountActions } from './actions';
import { accountState } from './state';
import { State } from './types';

export default function account(state = accountState, action: AccountActions): State {
  switch (action.type) {
    case types.REQUEST_ORDERS:
      return {
        ...state,
        orders: [],
        errMsg: '',
        isFetching: true,
      };
    case types.ERROR_ORDERS_GET_DATA_TICKET:
      return {
        ...state,
        dataTicket: {
          statusCode: 0,
          errorType: action.payload,
          tickets: [],
        },
        dataTicketIsFetching: false,
      };
    case types.ERROR_ORDERS_GET_DATA_TICKETLINES:
      return {
        ...state,
        dataTicketlines: {
          statusCode: 0,
          errorType: action.payload,
          orderNumber: 0,
          storeName: '',
          total: 0,
          items: [],
        },
        dataTicketlinesIsFetching: false,
      };
    case types.REQUEST_DATA_TICKET:
      return {
        ...state,
        dataTicket: {
          statusCode: 0,
          errorType: '',
          tickets: [],
        },
        errMsg: '',
        dataTicketIsFetching: true,
      };
    case types.REQUEST_DATA_TICKETLINES:
      return {
        ...state,
        dataTicketlines: {
          statusCode: 0,
          errorType: '',
          orderNumber: 0,
          storeName: '',
          total: 0,
          items: [],
        },
        errMsg: '',
        dataTicketlinesIsFetching: true,
      };
    case types.ERROR_ORDERS:
      return {
        ...state,
        orders: [],
        errMsg: action.payload,
        isFetching: false,
      };
    case types.SUCCESS_ORDERS:
      return {
        ...state,
        errMsg: '',
        isFetching: false,
        orders: action.payload,
      };
    case types.REQUEST_ORDER:
      return {
        ...state,
        errMsg: '',
        isFetching: true,
      };
    case types.ERROR_ORDER:
      return {
        ...state,
        errMsg: action.payload,
        isFetching: false,
      };
    case types.SUCCESS_ORDER:
      return {
        ...state,
        errMsg: '',
        isFetching: false,
        order: action.payload,
      };
    case types.SUCCESS_DATA_TICKET:
      return {
        ...state,
        errMsg: '',
        dataTicket: action.payload,
        dataTicketIsFetching: false,
      };
    case types.SUCCESS_DATA_TICKETLINES:
      return {
        ...state,
        errMsg: '',
        dataTicketlines: action.payload,
        dataTicketlinesIsFetching: false,
      };
    case types.SUCCESS_USER:
      return {
        ...state,
        isFetching: false,
        user: action.payload,
      };
    case types.SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    default:
      return state;
  }
}
